import { Api } from '../api';
import { alerts } from '../endpoints';
import type { ApiResponse } from '../../models';
import type {
  AddDeclinedAuthRequest,
  AddMinimalBalanceRequest,
  AlertSubscriptionResponse,
  IAlertsUpdate,
  UpdateDeclinedAuthRequest,
  UpdateMinimalBalanceRequest,
} from './models';

export class AlertsApi extends Api {
  static addMinimalBalance = (request: AddMinimalBalanceRequest, signal?: AbortSignal) =>
    this.post<AddMinimalBalanceRequest, ApiResponse<AlertSubscriptionResponse>>({ url: alerts.minimalBalanceAdd(), data: request, signal });

  static addDeclinedAuth = (request: AddDeclinedAuthRequest, signal?: AbortSignal) =>
    this.post<AddDeclinedAuthRequest, ApiResponse<AlertSubscriptionResponse>>({ url: alerts.declinedAuthAdd(), data: request, signal });

  static updateMinimalBalance = ({ request, subscriptionId }: IAlertsUpdate<UpdateMinimalBalanceRequest>, signal?: AbortSignal) =>
    this.put<UpdateMinimalBalanceRequest, ApiResponse<AlertSubscriptionResponse>>({
      url: alerts.minimalBalanceUpdate(subscriptionId),
      data: request,
      signal,
    });

  static updateDeclinedAuth = ({ request, subscriptionId }: IAlertsUpdate<UpdateDeclinedAuthRequest>, signal?: AbortSignal) =>
    this.put<UpdateDeclinedAuthRequest, ApiResponse<AlertSubscriptionResponse>>({
      url: alerts.declinedAuthUpdate(subscriptionId),
      data: request,
      signal,
    });

  static deleteSubscription = ({ subscriptionId }: { subscriptionId: string }) =>
    this.delete<unknown, unknown>({ url: alerts.deleteSubscription(subscriptionId) });
}
